// extracted by mini-css-extract-plugin
module.exports = {"heading":"store-faqs_heading__HdK5P","cantFindWhatYoureLookingFor":"store-faqs_cantFindWhatYoureLookingFor__vAge4","button":"store-faqs_button__Hpo1m"};